import { useSearchParams } from 'react-router-dom';
import { useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import { Toast } from 'primereact/toast';
import useApi from 'hooks/useApi';

export default function LoginPage() {
    const auth = useAuth();
    const app = useApp();
    const api = useApi();
    const [searchParams] = useSearchParams();
    const [rememberUser, setRememberUser] = useState(false);
    const [passReset, setPassReset] = useState(false);
    const [loadingReset, setLoadingReset] = useState(false);
    const [loadingLogin, setLoadingLogin] = useState(false);
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [newpassword, setNewpassword] = useState('');
    const [repeatnewpassword, setRepeatNewpassword] = useState('');
    const [userid, setUserID] = useState(8);

    const toast = useRef(null);

    const showError = (str) => {
        toast.current.show({ severity: 'error', summary: 'Erro de Autenticação', detail: str, life: 3500 });
    };

    const showInfo = (str) => {
        toast.current.show({ severity: 'info', summary: 'Aviso', detail: str, life: 3500 });
    };

    const loginAsync = async () => {
        setLoadingLogin(true);
        const response = await api.post("auth/login", { username: userName, password: password })
            .catch(error => {
                if (error.response) {
                    if (error.response.status === 401) {
                        showError("Usuário ou senha inválidos.");
                    } else if (error.response.status === 403) {
                        showError("Acesso negado.");
                    } else if (error.response.status === 500) {
                        showError("Erro interno do servidor.");
                    } else {
                        showError("Erro ao tentar autenticar. Tente novamente.");
                    }
                } else {
                    showError("Não foi possível conectar ao servidor.");
                }
                return error.response;
            });

        if (!response) {
            setLoadingLogin(false);
            return null;
        }
        return response.data;
    };

    function handleSubmit() {
        if (!userName.trim() || !password) {
            showError("Por favor, preencha o usuário e a senha.");
            return;
        }

        loginAsync()
            .then(loginData => {
                if (loginData?.token) {
                    if (loginData.passreset === true) {
                        setPassReset(true);
                        setUserID(loginData.userid);
                        showInfo('Senha expirada, por favor redefina sua senha.');
                    } else {
                        auth.login(loginData.token);
                        const returnUrl = searchParams.get('redirect') || '/home';
                        app.navigate(returnUrl);
                    }
                } else if (loginData?.nextpage) {
                    app.navigate(loginData.nextpage);
                }
            })
            .finally(() => {
                setLoadingLogin(false);
            });
    }

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleUserNameChange = (e) => {
        setUserName(e.target.value);
    };

    const handleCancel = () => {
        setPassReset(false);
        setUserName('');
        setPassword('');
        setNewpassword('');
        setRepeatNewpassword('');
    };

    const handleRepeatNewPasswordChange = (e) => {
        setRepeatNewpassword(e.target.value);
    };

    const handleNewPasswordChange = (e) => {
        setNewpassword(e.target.value);
    };

    const handleChangePass = () => {
        if (!newpassword || !repeatnewpassword) {
            showError("Preencha e confirme a nova senha.");
            return;
        }

        if (newpassword !== repeatnewpassword) {
            showError("As senhas informadas não coincidem.");
            return;
        }

        setLoadingReset(true);
        const formData = {
            CurrentPass: password,
            NewPass: newpassword,
            ConfirmPass: repeatnewpassword,
            UserId: userid
        };

        api.post("auth/ChangePass", formData)
            .then(response => {
                if (response.data?.token) {
                    auth.login(response.data.token);
                    app.navigate('/home');
                } else {
                    showError('Erro ao redefinir a senha.');
                }
            })
            .catch(() => {
                showError('Erro ao redefinir a senha. Verifique os requisitos.');
            })
            .finally(() => {
                setLoadingReset(false);
            });
    };

    return (
        <div className="login-split-page flex w-full">
            <Toast ref={toast} />

            <style>{`
                .login-split-page {
                    background-color: #0f172a;
                    height: 100vh;
                    max-height: 100vh;
                    width: 100%;
                    overflow: hidden;
                }
                .login-banner-container {
                    background-image: linear-gradient(180deg, rgba(15, 23, 42, 0.5) 0%, rgba(15, 23, 42, 0.25) 40%, rgba(15, 23, 42, 0.95) 100%), url('/images/login_epi_banner.jpg');
                    background-size: cover;
                    background-position: center;
                    position: relative;
                    height: 100vh;
                    max-height: 100vh;
                    overflow: hidden;
                }
                .login-form-side {
                    background: radial-gradient(circle at 80% 25%, rgba(37, 99, 235, 0.16) 0%, rgba(15, 23, 42, 1) 100%), #0f172a;
                    height: 100vh;
                    max-height: 100vh;
                    overflow: hidden;
                    border-left: 1px solid rgba(255, 255, 255, 0.08);
                }
                .login-input-dark {
                    background-color: #1e293b !important;
                    border: 1px solid rgba(255, 255, 255, 0.14) !important;
                    border-radius: 8px !important;
                    height: 46px !important;
                    font-size: 0.95rem !important;
                    color: #f8fafc !important;
                    transition: border-color 0.2s, box-shadow 0.2s;
                }
                .login-input-dark:focus {
                    border-color: #3b82f6 !important;
                    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25) !important;
                    background-color: #1e293b !important;
                }
                .login-btn-action {
                    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
                    border: none !important;
                    border-radius: 8px !important;
                    height: 46px !important;
                    font-weight: 700 !important;
                    font-size: 1rem !important;
                    letter-spacing: 0.3px;
                    transition: all 0.2s ease;
                    box-shadow: 0 4px 14px rgba(37, 99, 235, 0.35) !important;
                }
                .login-btn-action:not(:disabled):hover {
                    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
                    box-shadow: 0 6px 20px rgba(37, 99, 235, 0.5) !important;
                    transform: translateY(-1px);
                }
                .login-btn-action:not(:disabled):active {
                    transform: translateY(0);
                }
            `}</style>

            {/* Lado Esquerdo: Banner Visual com Imagem Industrial de EPIs (Sem cabeçalho solto no topo) */}
            <div className="login-banner-container hidden lg:flex flex-column justify-content-end p-5 lg:p-7 flex-1">
                <div className="p-3 border-round-2xl" style={{ background: "rgba(15, 23, 42, 0.7)", backdropFilter: "blur(10px)", maxWidth: "520px", border: "1px solid rgba(255, 255, 255, 0.12)" }}>
                    <div className="flex align-items-center gap-2 mb-2">
                        <i className="pi pi-shield text-blue-400 text-xl" />
                        <span className="text-xs uppercase font-bold text-blue-400 tracking-wider">Segurança & Conformidade</span>
                    </div>
                    <h1 className="text-2xl lg:text-3xl font-bold text-white mb-2 line-height-2">
                        Controle de Estoque & EPIs
                    </h1>
                    <p className="text-sm text-300 line-height-3 m-0">
                        Gerencie requisições, periodicidade de troca, fichas de entrega e estoque de segurança com total rastreabilidade e eficiência operacional.
                    </p>
                </div>
            </div>

            {/* Lado Direito: Área de Login Moderna com Cores de Destaque e Sem Rolagem */}
            <div className="login-form-side flex-1 flex flex-column justify-content-between align-items-center p-3 sm:p-5">
                <div className="w-full" style={{ height: '8px' }}>
                    {/* Espaçador superior */}
                </div>

                {/* Container Central do Formulário */}
                <div className="w-full my-auto" style={{ maxWidth: '390px' }}>
                    {/* Logo ELETRO apontada na imagem inserida na área de login */}
                    <div className="flex align-items-center gap-3 mb-4 p-2 border-round-xl" style={{ background: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(255, 255, 255, 0.08)' }}>
                        <img
                            src="/images/logo.png"
                            alt="Eletro Logo"
                            style={{ height: '42px', width: 'auto', objectFit: 'contain' }}
                        />
                        <div>
                            <div className="text-xl font-bold text-white tracking-wide" style={{ letterSpacing: '0.8px' }}>
                                ELETRO
                            </div>
                            <div className="text-xs text-400 font-medium">
                                Gestão & Controle de Estoque de EPIs
                            </div>
                        </div>
                    </div>

                    {passReset ? (
                        /* Formulário de Redefinição de Senha */
                        <div>
                            <div className="mb-3">
                                <h2 className="text-2xl font-bold text-white m-0 mb-1">Redefinir Senha</h2>
                                <p className="text-400 text-sm m-0">Sua senha expirou. Por favor, cadastre uma nova senha.</p>
                            </div>

                            <form onSubmit={(e) => { e.preventDefault(); handleChangePass(); }}>
                                <div className="mb-3">
                                    <label htmlFor="newpassword" className="block text-sm font-semibold mb-1 text-300">
                                        Nova Senha
                                    </label>
                                    <Password
                                        id="newpassword"
                                        name="newpassword"
                                        value={newpassword}
                                        onChange={handleNewPasswordChange}
                                        placeholder="Digite a nova senha"
                                        className="w-full"
                                        inputClassName="w-full login-input-dark"
                                        feedback={false}
                                        toggleMask
                                        required
                                        autoFocus
                                    />
                                </div>

                                <div className="mb-4">
                                    <label htmlFor="repeatnewpassword" className="block text-sm font-semibold mb-1 text-300">
                                        Confirmar Nova Senha
                                    </label>
                                    <Password
                                        id="repeatnewpassword"
                                        name="repeatnewpassword"
                                        value={repeatnewpassword}
                                        onChange={handleRepeatNewPasswordChange}
                                        placeholder="Confirme a nova senha"
                                        className="w-full"
                                        inputClassName="w-full login-input-dark"
                                        feedback={false}
                                        toggleMask
                                        required
                                    />
                                </div>

                                <div className="flex gap-2">
                                    <Button
                                        type="button"
                                        onClick={handleCancel}
                                        label="Cancelar"
                                        className="p-button-outlined p-button-secondary w-full"
                                        style={{ height: '46px', borderRadius: '8px', color: '#cbd5e1', borderColor: 'rgba(255, 255, 255, 0.2)' }}
                                        disabled={loadingReset}
                                    />
                                    <Button
                                        type="submit"
                                        label={loadingReset ? "Salvando..." : "Salvar Senha"}
                                        loading={loadingReset}
                                        className="w-full login-btn-action"
                                    />
                                </div>
                            </form>
                        </div>
                    ) : (
                        /* Formulário Principal de Acesso */
                        <div>
                            <div className="mb-3">
                                <h2 className="text-2xl font-bold text-white m-0 mb-1">Acessar o Sistema</h2>
                                <p className="text-400 text-sm m-0">Bem-vindo. Por favor, insira suas credenciais.</p>
                            </div>

                            <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                                <div className="mb-3">
                                    <label htmlFor="username" className="block text-sm font-semibold mb-1 text-300">
                                        Usuário
                                    </label>
                                    <span className="p-input-icon-left w-full">
                                        <i className="pi pi-user text-400" />
                                        <InputText
                                            id="username"
                                            name="username"
                                            type="text"
                                            value={userName}
                                            onChange={handleUserNameChange}
                                            placeholder="admin@mail.com.br"
                                            className="w-full login-input-dark"
                                            autoComplete="username"
                                            autoFocus
                                            required
                                        />
                                    </span>
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="password" className="block text-sm font-semibold mb-1 text-300">
                                        Senha
                                    </label>
                                    <Password
                                        id="password"
                                        name="password"
                                        value={password}
                                        onChange={handlePasswordChange}
                                        placeholder="••••••••"
                                        className="w-full"
                                        inputClassName="w-full login-input-dark"
                                        feedback={false}
                                        toggleMask
                                        autoComplete="current-password"
                                        required
                                    />
                                </div>

                                <div className="flex align-items-center justify-content-between mb-3 mt-1">
                                    <div className="field-checkbox m-0 flex align-items-center">
                                        <Checkbox
                                            inputId="rememberme"
                                            checked={rememberUser}
                                            onChange={(e) => setRememberUser(e.checked)}
                                        />
                                        <label htmlFor="rememberme" className="text-sm text-300 ml-2 cursor-pointer select-none">
                                            Lembrar de mim
                                        </label>
                                    </div>
                                </div>

                                <Button
                                    type="submit"
                                    label={loadingLogin ? "Acessando..." : "Entrar"}
                                    icon={loadingLogin ? "" : "pi pi-arrow-right"}
                                    iconPos="right"
                                    loading={loadingLogin}
                                    className="w-full login-btn-action"
                                />
                            </form>
                        </div>
                    )}
                </div>

                {/* Rodapé com Versão */}
                <div className="w-full text-center py-2">
                    <span className="text-xs text-500 font-medium">
                        Versão: 2026.11.03
                    </span>
                </div>
            </div>
        </div>
    );
}
